<div class="layout">
    <nav class="navbar navbar-light navbar-fixed-top pt-1">
        <app-navbar></app-navbar>
    </nav>
    <div>
        <router-outlet></router-outlet>
    </div>
    <footer class="position-absolute bottom-0" style="width: 100%;">
        <app-footer></app-footer>
    </footer>
</div>